import script from "./CompanySelectionPage.vue?vue&type=script&lang=ts"
export * from "./CompanySelectionPage.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__